import Crud from '../components/ServicesAdditional/Crud'
import Entity from '../components/ServicesAdditional/Add'
import Manage from '../components/ServicesAdditional/Manage'

let routes = {
    path: '/services_additionals',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/services_additionals/add',
            name: 'Novo Serviço Adicional',
            component: Entity
        },
        {
            path: '/services_additionals/edit/:id?',
            name: 'Editar Serviço Adicional',
            component: Entity
        },
        {
            path: '/services_additionals',
            name: 'Serviços Adicionais',
            component: Crud
        },
        {
            path: '/services_additionals/manage',
            name: 'Serviços Adicionais - Solicitados',
            component: Manage
        },
    ]
};

export default routes


// WEBPACK FOOTER //
// ./src/router/services_additional.js